var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading"},[_c('v-progress-circular',{staticClass:"loader",attrs:{"size":50,"color":"primary","indeterminate":""}}),_c('img',{attrs:{"src":require("../../assets/img/logo-light.png")}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }